var _AutocompletePopupCloser_view, _AutocompletePopupCloser_timer;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import { closeAutocomplete } from '../extensions/behavior/Autocomplete';
export class AutocompletePopupCloser {
    constructor(view) {
        _AutocompletePopupCloser_view.set(this, void 0);
        _AutocompletePopupCloser_timer.set(this, void 0);
        this.popupEscapeKeyHandler = () => {
            this.closeAutocomplete();
        };
        this.popupOutsideClickHandler = () => {
            if (!__classPrivateFieldGet(this, _AutocompletePopupCloser_view, "f").hasFocus()) {
                __classPrivateFieldSet(this, _AutocompletePopupCloser_timer, setTimeout(() => {
                    __classPrivateFieldSet(this, _AutocompletePopupCloser_timer, undefined, "f");
                    if (!__classPrivateFieldGet(this, _AutocompletePopupCloser_view, "f").hasFocus()) {
                        this.closeAutocomplete();
                    }
                }, 20), "f");
            }
        };
        __classPrivateFieldSet(this, _AutocompletePopupCloser_view, view, "f");
    }
    closeAutocomplete() {
        closeAutocomplete(__classPrivateFieldGet(this, _AutocompletePopupCloser_view, "f"));
    }
    cancelTimer() {
        if (__classPrivateFieldGet(this, _AutocompletePopupCloser_timer, "f") !== undefined) {
            clearTimeout(__classPrivateFieldGet(this, _AutocompletePopupCloser_timer, "f"));
            __classPrivateFieldSet(this, _AutocompletePopupCloser_timer, undefined, "f");
        }
    }
}
_AutocompletePopupCloser_view = new WeakMap(), _AutocompletePopupCloser_timer = new WeakMap();
